import TextField from "@mui/material/TextField";
import { styled } from "@mui/material/styles";

export const DateTimePickerRenderInput = styled(TextField)(({ theme }) => ({
    fontSize: theme.typography.fontSize,
    "& .MuiInputBase-input:not([disabled])": {
        cursor: "pointer",
    },
    "& .MuiButtonBase-root": {
        marginRight: "-0.5rem",
    },
})) as typeof TextField;
